import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
} from "@mui/material";
import NavBar from "../Navigation bar/Navbar";
import { service_url } from "../../Configs/mysqlconfig";

const multiOptions = ['Option A', 'Option B', 'Option C'];

export default function OutStationLogistics() {
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);


  const [orderType, setOrderType] = useState('All Orders');
  const [orderTypes, setOrderTypes] = useState(['All Orders','Submitted', 'Not Submitted']);

  const [transporterName, setTransporterName] = useState('All Transporters');
  const [transporterLists, setTransporterLists] = useState(['All Transporters']);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchText, setSearchText] = useState('');


    const [originalRows, setOriginalRows] = useState([]);
    const [originalFiltered, setOriginalFiltered] = useState([]);

    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [handleData, setHandleData] = useState("Start");



    const handleResponse = () => {
      setHandleData(true)
    }
  

 const handleGo = () => {
  setLoading(true);
  setError("");
  fetch(
    `${service_url}/api/superzop/delivery/getTableData?start_date=${startDate}&end_date=${endDate}`,
    { method: "GET", redirect: "follow" }
  )
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then((apiData) => {

      setOriginalRows(apiData);

      // setOrderTypes(['All Orders', ...new Set(apiData.map(r => r.submit_status).filter(Boolean))]);
      setTransporterLists(['All Transporters', ...new Set(apiData.map(r => r.transporter_name).filter(Boolean))]);
      
      const filteredRows = apiData
        .filter((r) => {
          if (orderType?.trim() === "All Orders") {
           return true
          }
      
          return r.submit_status?.toLowerCase().trim() === orderType.toLowerCase().trim();
     
       
        })
        .filter((r) => {
          if (transporterName?.trim() === "All Transporters") {
            return true
          }
       
          return r.transporter_name?.toLowerCase().trim() === transporterName?.toLowerCase().trim();
     
        })
        
      setOriginalFiltered(filteredRows);
      setRows(filteredRows);
    })
    .catch((err) => {
      console.error(err);
      setError("Failed to load data");
    })
    .finally(() => setLoading(false));
    };

 



    useEffect(() => {
      if (handleData)
      {
      handleGo()
      setHandleData(false);
      }
    }, [handleData]);

 



const searchIconSvg = (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '24px',
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="20"
      height="20"
      style={{ display: 'block' }}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 21l-4.35-4.35M16.65 16.65A7.5 7.5 0 1016.65 2a7.5 7.5 0 000 14.65z"
      />
    </svg>
  </Box>
);


  
  const exportToExcel = () => {
   
    const headers = [
      'Warehouse',
      'Route',
      'Retailer ID',
      'Order ID',
      'Order Date',
      'Delivery Date',
      'Order Amount',
      'Shipped Amount',
      'Delivered Amount',
      'Shipped Weight',
      'Transporter Name',
      'Transporter Cost',
      // 'View Receipt',
    ];

    
    const dataRows = rows.map(r => [
      r.city,
      r.driver_id,
      r.retailer_id,
      r.order_number,
      new Date(r.order_date).toLocaleDateString(),
      new Date(r.doh_delivery_date).toLocaleDateString(),
      r?.total_amt ? parseFloat(r.total_amt).toFixed(2) : "NA",
      r?.shipped_amt ? parseFloat(r.shipped_amt).toFixed(2) : "NA",
      r?.delivered_amt ? parseFloat(r.delivered_amt).toFixed(2) : "NA",
      r?.order_weight_kg ? parseFloat(r.order_weight_kg).toFixed(2) : "NA",
      r.transporter_name || '',
      r.transporter_cost ? parseFloat(r.transporter_cost).toFixed(2) : "NA",
      // r.receipt ? r.receipt : 'NA'
    ]);

    
    const csvContent = [
      headers.join(','),
      ...dataRows.map(row => row.join(','))
    ].join('\n');

    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'outstation_logistics.csv';
    a.click();
    URL.revokeObjectURL(url);
  };



  return (

    <> {!loading ?  <>
  <NavBar />
  <br/>
  <br/>
  <br/>         

    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom >
        Outstation Logistics
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
        <TextField
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          inputProps={{
            max: new Date().toISOString().split('T')[0]
          }}
        />
        <TextField
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
           inputProps={{
            max: new Date().toISOString().split('T')[0]
          }}
        />


            <Button
                  variant="contained"
                  color="primary"
                  onClick={()=> handleResponse()}
                  disabled={loading}
                >
                  {loading ? "Loading…" : "GO"}
            </Button>



        <FormControl sx={{ minWidth: 150 }}>
  <InputLabel>Order Type</InputLabel>
  <Select
    value={orderType}
    onChange={(e) => {

      const newType = e.target.value || 'All Orders';
      setOrderType(newType);


          if(newType?.toLowerCase()?.trim() === "not submitted")
        {
            setTransporterName('All Transporters');

              const filteredRows = originalRows
            .filter((r) => {
              return (
                r.submit_status
                  ?.toLowerCase()
                  .trim() === newType.toLowerCase().trim()
              );
            })
         

          setOriginalFiltered(filteredRows);
          setRows(filteredRows);
          setSearchText('');
        }
        else{
      const filteredRows = originalRows
        .filter((r) => {
          if (newType.trim() === "All Orders") {
            return true;
          }
          return (
            r.submit_status
              ?.toLowerCase()
              .trim() === newType.toLowerCase().trim()
          );
        })
        .filter((r) => {
          if (transporterName?.trim() === "All Transporters") {
            return true;
          }
          return (
            r.transporter_name
              ?.toLowerCase()
              .trim() === transporterName.toLowerCase().trim()
          );
        });
    

      setOriginalFiltered(filteredRows); 
      setRows(filteredRows);
      setSearchText('');

        }
      
 
    }}
    label="Order Type"
  >
    {orderTypes.map((type) => (
      <MenuItem key={type} value={type}>
        {type}
      </MenuItem>
    ))}
  </Select>
        </FormControl>

      <FormControl sx={{ minWidth: 150 }}>
      <InputLabel>Transporter Name</InputLabel>
      <Select
        value={transporterName}
        onChange={(e) => {
   
          const newTrans = e.target.value || 'All Transporters';
          setTransporterName(newTrans);

          const filteredRows = originalRows
            .filter((r) => {
              if (orderType?.trim() === "All Orders") {
                return true;
              }
              return (
                r.submit_status
                  ?.toLowerCase()
                  .trim() === orderType.toLowerCase().trim()
              );
            })
            .filter((r) => {
              if (newTrans.trim() === "All Transporters") {
                return true;
              }
              return (
                r.transporter_name
                  ?.toLowerCase()
                  .trim() === newTrans.toLowerCase().trim()
              );
            });

          setOriginalFiltered(filteredRows);
          setRows(filteredRows);
          setSearchText('');

        }}
        label="Transporter Name"
      >
        {transporterLists.map((name) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>


        {/* <FormControl sx={{ minWidth: 200 }}>
          <InputLabel shrink>Multi Select</InputLabel>
          <Select
            multiple
            value={selectedOptions}
            onChange={(e) => setSelectedOptions(e.target.value)}
            renderValue={(selected) => selected.join(', ')}
            label="Multi Select"
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
          >
            {multiOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

       

             <Button
              variant="contained"
              onClick={exportToExcel}
              disabled={rows.length === 0}
          >
            Export
          </Button>
          
     <TextField
        size="small"
        variant="outlined"
        placeholder="Search by Order No"
        value={searchText}
        onChange={(e) => 
          {
            setSearchText(e.target.value);
           
            const newSearchedRow = originalFiltered.filter((r) => {

              if(e.target.value)
              {
              return r.order_number && r.order_number.toString().includes(e.target.value) 
              }
              return false
          });

          if(e.target.value)
          {
            setRows(newSearchedRow)     
          }
          else{
           setRows(originalFiltered)
          }

          }}
        InputProps={{
            startAdornment: (
            <InputAdornment position="start" sx={{ height: '100%', alignItems: 'center', ml: 'auto' }}>
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
            justifyContent: 'center',
            height: '24px',
            width: '24px',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="20"
            height="20"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </Box>
      </InputAdornment>
    ),
  }}
/>

      </Box>

       {error && (
                <Typography color="error" sx={{ mb: 2 }}>
                  {error}
                </Typography>
              )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: 'primary.main' }}>
            <TableRow>
              {[
               'Warehouse',
              'Route',
              'Retailer ID',
              'Order ID',
              'Order Date',
              'Delivery Date',
              'Order Amount',
              'Shipped Amount',
              'Delivered Amount',
              'Shipped Weight',
              'Transporter Name',
              'Transporter Cost',
              'View Receipt',
              ].map((header) => (
                <TableCell key={header} sx={{ color: 'white', fontWeight: 'bold' }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
           <TableBody>
                      {rows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            No Data Found
                          </TableCell>
                        </TableRow>
                      ) : (
                        rows.map((row,index) => (
                          <TableRow key={index}>
                            <TableCell>{row.city}</TableCell>
                            <TableCell>{row.driver_id}</TableCell>
                            <TableCell>{row.retailer_id}</TableCell>
                            <TableCell>{row.order_number}</TableCell>
                            <TableCell>
                              {new Date(row.order_date).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              {new Date(row.doh_delivery_date).toLocaleDateString()}
                            </TableCell>
                            <TableCell>{row?.total_amt ? parseFloat(row.total_amt).toFixed(2) : "-"}</TableCell>
                             <TableCell>{row?.shipped_amt ? parseFloat(row.shipped_amt).toFixed(2) : "-"}</TableCell>
                            <TableCell>{row?.delivered_amt ? parseFloat(row.delivered_amt).toFixed(2) : "-"}</TableCell>
                            <TableCell>{row?.order_weight_kg ? parseFloat(row.order_weight_kg).toFixed(2) : "-"}</TableCell>
                            <TableCell>{row.transporter_name || "-"}</TableCell>
                            <TableCell>{row?.transporter_cost ? parseFloat(row.transporter_cost).toFixed(2) : "-"}</TableCell>
                            <TableCell>
                              {row.receipt ? (
                                <Button
                                  size="small"
                                  onClick={() =>
                                    window.open(row.receipt, "_blank")
                                  }
                                >
                                  View
                                </Button>
                              ) : (
                                "-"
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
        </Table>
      </TableContainer>
    </Box>
    </>
   : 
   
   
   <>
   
      <NavBar />
      <br/>
      <br/>
      <br/> 
   <Box sx={{ p: 3 }}>       
    <Typography variant="h4" gutterBottom >
      Outstation Logistics
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: 'primary.main' }}>
            <TableRow>
            </TableRow>
          </TableHead>
           <TableBody>
                    
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                      Loading Please Wait...
                          </TableCell>
                        </TableRow>
                 
                    </TableBody>
        </Table>
      </TableContainer>
   </Box></>}</>
  );
}
